
interface NavbarProps {
  isFixed: boolean;
}

export default function Navbar({ isFixed }: NavbarProps) {
  return (
    <nav className="fixed top-0 w-full z-50 bg-white shadow-md transition-all duration-300">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center">
          <img
            src="https://static.readdy.ai/image/929818ef5c2fcaad39934da27e65f1be/04a7d326eda896b61fddd55d8c91a5cb.png"
            alt="FIRE OUT"
            className="h-12 w-auto object-contain"
          />
        </div>
        <a
          href="https://fireout.stores.jp/inquiry"
          target="_blank"
          rel="noopener noreferrer"
          className="px-6 py-2.5 rounded-full text-sm font-bold transition-all whitespace-nowrap cursor-pointer bg-red-600 text-white hover:bg-red-700"
        >
          無料お見積もり・導入のご相談
        </a>
      </div>
    </nav>
  );
}
